export default __webpack_public_path__ + "static/media/ic-complete.521ee740.svg";